import { PageSettings, Survey } from "@tree-company/tree-query";
import { page_intro } from "./page_intro";
import { Languages } from "@tree-company/collect-js-client";
import { page_privacy } from "./page_privacy";
import { scale_pages } from "./scale_questions";
import { Result } from "../components/result";
import { translationFromKey } from "./helpers";
import ErrorPage from "../components/error_component";

let responseCollectorURL = import.meta.env.VITE_COLLECT_URL;
if (import.meta.env.DEV && responseCollectorURL === undefined) {
  responseCollectorURL = "http://localhost:3000";
}

const params = new URLSearchParams(window.location.search);
const bpact_id = params.get("linkname") === "bp" ? params.get("p_id") : null;

export const survey = new Survey({
  pages: [
    page_intro,
    ...scale_pages,
    page_privacy,
    {
      key: "page_outro",
      title: translationFromKey("result.title"),
      order: 98,
      component: Result,
      htmlAttributes: { class: "page--with-logo" },
      sections: [],
    },
    {
      key: "page_error",
      title: translationFromKey("error.title"),
      order: 98,
      component: ErrorPage,
      htmlAttributes: { class: "page--with-logo" },
      sections: [],
    },
  ] as unknown as [PageSettings, ...PageSettings[]],
  key: "survey",
  availableLanguages: [Languages.en],
  responseCollector: {
    apiSettings: {
      url: responseCollectorURL,
      projectKey: import.meta.env.VITE_COLLECT_KEY,
    },
    defaultValues: {
      surveyVersion: "v1",
      language: Languages.nl,
      initialAnswers: {
        bpact_id,
      },
    },
  },
});
